
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/faqs",
      function () {
        return require("private-next-pages/elections/faqs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/faqs"])
      });
    }
  